Vue.component('v-events-page', require('./components/EventsPage.vue').default);
Vue.component('v-events-list', require('./components/EventsList.vue').default);
Vue.component('v-event-form', require('./components/EventForm.vue').default);
Vue.component('v-event-page', require('./components/EventPage.vue').default);
Vue.component('v-event-info', require('./components/EventInfo.vue').default);

Vue.component('v-event-jobs-page', require('./components/EventJobsPage.vue').default);
Vue.component('v-event-jobs-list', require('./components/EventJobsList.vue').default);
Vue.component('v-event-job-form', require('./components/EventJobForm.vue').default);

Vue.component('v-event-job-timeslots-page', require('./components/EventJobTimeslotsPage.vue').default);
Vue.component('v-event-job-timeslots-list', require('./components/EventJobTimeslotsList.vue').default);
Vue.component('v-event-job-timeslot-form', require('./components/EventJobTimeslotForm.vue').default);
Vue.component('v-event-job-timeslots-embedded', require('./components/EventJobTimeslotsEmbedded.vue').default);

Vue.component('v-event-volunteers-page', require('./components/EventVolunteersPage.vue').default);
Vue.component('v-event-volunteers-list', require('./components/EventVolunteersList.vue').default);
Vue.component('v-event-available-jobs-list', require('./components/EventAvailableJobsList.vue').default);
Vue.component('v-member-form', require('./components/MemberForm.vue').default);

Vue.component('v-member-events-page', require('./components/MemberEventsPage.vue').default);
Vue.component('v-member-events-list', require('./components/MemberEventsList.vue').default);